// extracted by mini-css-extract-plugin
export default {"container":"absoluteWrapper_container__kpv1O","button":"absoluteWrapper_button__YAT+0","children":"absoluteWrapper_children__8w2rI"};